import * as React from 'react'

import { clsx } from 'clsx'

import styles from './PageLayout.module.css'

type PageLayoutSize = 'narrow' | 'wide' | 'full'

const sizeClassNames: Partial<Record<PageLayoutSize, string>> = {
  narrow: styles.narrow,
  full: styles.full,
}

type PageLayoutProps = React.HTMLAttributes<HTMLDivElement>

const PageLayoutRoot = React.forwardRef<HTMLDivElement, PageLayoutProps>(
  ({ children, className, ...props }, forwardedRef) => (
    <div ref={forwardedRef} className={clsx(styles.root, className)} {...props}>
      {children}
    </div>
  ),
)

PageLayoutRoot.displayName = 'PageLayout'

type PageLayoutContainerProps = React.HTMLAttributes<HTMLElement> & {
  size?: PageLayoutSize
  as?: 'div' | 'main' | 'section'
}

const PageLayoutContainer = React.forwardRef<
  HTMLElement,
  PageLayoutContainerProps
>(
  (
    {
      children,
      size = 'wide',
      as: Element = 'div',
      className,
      ...props
    }: PageLayoutContainerProps,
    forwardedRef,
  ) =>
    React.createElement(
      Element,
      {
        ref: forwardedRef,
        className: clsx(styles.container, sizeClassNames[size], className),
        ...props,
      },
      children,
    ),
)

PageLayoutContainer.displayName = 'PageLayout.Container'

const PageLayout = Object.assign(PageLayoutRoot, {
  Container: PageLayoutContainer,
})

export { PageLayout }
export type { PageLayoutProps, PageLayoutContainerProps }
